module.exports = __webpack_public_path__ + "img/target.4a145f89.svg";